import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=70eadfc2&scoped=true&lang=pug"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eadfc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70eadfc2')) {
      api.createRecord('70eadfc2', component.options)
    } else {
      api.reload('70eadfc2', component.options)
    }
    module.hot.accept("./IconButton.vue?vue&type=template&id=70eadfc2&scoped=true&lang=pug", function () {
      api.rerender('70eadfc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/buttons/IconButton.vue"
export default component.exports